import { createFileRoute } from "@tanstack/react-router";
import ExternalRedirect from "@/components/ExternalRedirect";
export const Route = createFileRoute("/intakeform")({
  component: IntakeFormRedirect,
  head() {
    return {
      meta: [
        {
          title: "Patient Intake Form | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Complete your patient intake form for depression treatment at Neuro Wellness TMS in Coral Springs, FL. SAINT® TMS, SPRAVATO®, and therapy options available.",
        },
        {
          property: "og:title",
          content: "Patient Intake Form | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Complete your patient intake form for depression treatment at Neuro Wellness TMS in Coral Springs, FL. SAINT® TMS, SPRAVATO®, and therapy options available.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/intakeform",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/intakeform",
        },
      ],
    };
  },
});
function IntakeFormRedirect() {
  return (
    <ExternalRedirect to="https://forms.wv3.io/form?formId=c33f7b2e-e605-4610-ac7a-95f015413bdd&companyId=c960f5ef-6246-4d97-93a6-aaecef308e40" />
  );
}
